export const STORAGE_KEY = 'sspTrackingSessionId';

function makeId(length: number): string {
    let result = '';
    const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
    }

    return result;
}

export function makeGUID(): string {
    return [makeId(8), makeId(4), makeId(4), makeId(4), makeId(10)].join('-');
}
